window.addEventListener("DOMContentLoaded", () => {
    const video = document.querySelector('.video-el')
    const videoBtn = document.querySelector('.control')

    videoBtn.addEventListener('click', () => {
        playVideo()
        if (videoBtn.getAttribute('listener') !== 'true'){
            video.addEventListener("click", () => {
                pauseVideo()
                videoBtn.classList.remove('hidden')
            })
            videoBtn.setAttribute('listener', 'true')
        }
    })

    function playVideo() {
        video.play();
        videoBtn.classList.add('hidden')
    }

    function pauseVideo() {
        video.pause()
        videoBtn.classList.remove('hidden')
    }

})
